import { CheckoutConfig, CheckoutStepType, DeliveryModePreferences } from '@spartacus/checkout/base/root';

export const customB2BCheckoutConfig: CheckoutConfig = {
  checkout: {
    steps: [
      {
        id: 'billingAddress',
        name: 'checkoutProgress.billingAddress',
        routeName: 'checkoutBillingAddress',
        type: [CheckoutStepType.PAYMENT_DETAILS],
      },
      {
        id: 'deliveryAddress',
        name: 'checkoutProgress.deliveryAddress',
        routeName: 'checkoutDeliveryAddress',
        type: [CheckoutStepType.DELIVERY_ADDRESS],
      },
    ],
    express: false,
    defaultDeliveryMode: [DeliveryModePreferences.FREE],
    guest: false,
  },
};
